import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  senderEmailsTitle: {
    defaultMessage: 'Sender Emails',
    description: 'Title for the sender emails section',
    id: 'fUt9ng',
  },
  senderEmailInstructions: {
    defaultMessage:
      'ShipStation will send notification emails from sender email addresses with authenticated domains. Authenticated domains increase your email deliverability. Add the email address to your store Branding settings, you can then verify the email and authenticate the domain.',
    description: 'Information on what sender emails are and how to set them up',
    id: 'QU+37R',
  },
  senderEmailsBanner: {
    defaultMessage:
      'While you can add emails with public domains (like gmail.com, yahoo.com, etc) and verify them for use in templates, these email addresses cannot be used as a sender email.',
    description: 'Extra information about using public domain emails',
    id: 'jIAc9Y',
  },
  learnMoreAboutDomainVerification: {
    defaultMessage: 'Learn about domain authentication in ShipStation',
    description: 'Link to help article about domain authentication',
    id: '15JtVc',
  },
  domainLoadingError: {
    defaultMessage: 'Failed to load domains',
    description: 'Error message when loading domains fails',
    id: '3GkZqo',
  },
  domainAuthenticationSuccess: {
    defaultMessage: 'Domain authenticated successfully',
    description: 'Success message when domain is authenticated',
    id: 'BwoT6n',
  },
  noSenderEmailsInstructions: {
    defaultMessage: 'Add an email address and ShipStation will send an email to verify ownership.',
    description: 'Instructions when there are no sender emails',
    id: 'jgDKpF',
  },
  storeSettingsLink: {
    defaultMessage: 'Go to Store Settings',
    description: 'Link to store settings',
    id: 'L4O86e',
  },
});
